import { createReducer } from '@reduxjs/toolkit';
import { Employee } from './actions';
import {
    listEmployeesRequest,
    listEmployeesSuccess,
    listEmployeesFailure,
    updateEmployeesRequest,
    updateEmployeesSuccess,
    updateEmployeesFailure,
    resetErrorRequest,
    getEmployeeRequest,
    getEmployeeSuccess,
    getEmployeeFailure,
    setEmployeeRequest,
    createEmployeeRequest,
} from './actions';

export interface EmployeeState {
    employees: Employee[];
    employee: Employee | null;
    loading: boolean;
    error: string | null;
}

const initialState: EmployeeState = {
    employees: [],
    employee: null,
    loading: false,
    error: null,
};

const employeeReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(resetErrorRequest, (state) => {
            state.error = null;
        })
        .addCase(listEmployeesRequest, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(listEmployeesSuccess, (state, action) => {
            state.employees = action.payload; // Set employees from the server
            state.loading = false;
        })
        .addCase(listEmployeesFailure, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        .addCase(updateEmployeesRequest, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(updateEmployeesSuccess, (state, action) => {
            action.payload.map((employee: Employee) => {
                let found = false;
                state.employees = state.employees.map((el: Employee) => {
                    if (el.id == employee.id) {
                        found = true;
                        return {
                            ...el,
                            ...employee,
                        }
                    }
                    return el;
                });
                if (!found) {
                    state.employees.push(employee);
                }
            });

            state.loading = false;
        })
        .addCase(updateEmployeesFailure, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        .addCase(getEmployeeRequest, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(getEmployeeSuccess, (state, action) => {
            state.employee = action.payload;
            state.loading = false;
        })
        .addCase(getEmployeeFailure, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        .addCase(setEmployeeRequest, (state, action) => {
            state.employee = action.payload;
            state.loading = true;
            state.error = null;
        })
        .addCase(createEmployeeRequest, (state) => {
            state.loading = true;
            state.error = null;
        })
});

export default employeeReducer;
